import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import ZettaDark from "../components/ZettaDark"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <ZettaDark />
  </Layout>
)

export default IndexPage
